import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//internal components
import PublicHeaderNavigation from "../../../Common/Header/HeaderNavigation";
import PublicFooterNavigation from "../../../Common/Footer/FooterNavigationRefresh";
import BreadCrumbPanelNew from "../../../Common/BreadCrumbPanelNew";
import VendorNavigation from "../../../Common/VendorNavigation";
import SearchResultPremium from "../../../Common/SearchResultPremium";
import TestimonialPremium from "../TestimonialPremium/TestimonialPremium";
import VendorFilter from "../../../Common/VendorFilter";
import PaginationPremium from "../../../Common/PaginationPremium";

const PremiumTestimonialRefresh = (props) => {
  const [paginationOn, setPaginationOn] = useState(1);
  const [itemOnPage, setItemOnPage] = useState(15);
  const [isLoader, setIsLoader] = useState(false);

  useEffect(() => {
    if (!!props?.location?.pathname) {
      const accSingleTriggers = document.querySelectorAll(
        ".js-acc-single-trigger"
      );
      accSingleTriggers.forEach((trigger) =>
        trigger.addEventListener("click", toggleAccordion)
      );
      const accSingleTriggers2 = document.querySelectorAll(".acc-toggle");
      accSingleTriggers2.forEach((trigger) =>
        trigger.addEventListener("click", toggleAccordion)
      );
      function toggleAccordion() {
        const items = document.querySelectorAll(".js-acc-item");
        const thisItem = this.parentNode;
        items.forEach((item) => {
          if (thisItem === item) {
            thisItem.classList.toggle("is-open");
            return;
          }
          item.classList.remove("is-open");
        });
      }
    }
  }, [props?.location?.pathname]);

  const toggleLoader = () => {
    setIsLoader(!isLoader);
  };

  function isFirstCharInRangeAtoJ(str) {
    if (str && str.length > 0) {
      let firstChar = str.charAt(0).toUpperCase();
      return firstChar >= "A" && firstChar <= "J";
    }
    return false; // Return false for empty, null, or undefined strings
  }

  const ShowContentOnTestimonial = (CSSnap, URLPathname) => {
    if (Object.keys(CSSnap).length > 0 && !!URLPathname) {
      let vendorSlug = URLPathname.split("/")[2];

      if (isFirstCharInRangeAtoJ(vendorSlug)) {
        if (!!CSSnap?.testimonial_content) {
          return ShowCaseTestimonialOverviewType1(
            CSSnap?.testimonial_content,
            URLPathname
          );
        } else {
          return (
            <p>
              Browse {props.vendorCommon.name} testimonials and customer
              references to help make the right purchasing decision
            </p>
          );
        }
      } else {
        if (!!CSSnap?.testimonial_content) {
          return ShowCaseTestimonialOverviewType5(
            CSSnap?.testimonial_content,
            URLPathname
          );
        } else {
          return (
            <p>
              Browse {props.vendorCommon.name} testimonials and customer
              references to help make the right purchasing decision
            </p>
          );
        }
      }
    }
  };

  const ShowCaseTestimonialOverviewType1 = (content) => {
    return (
      <>
        <h2>Testimonials Overview</h2>
        {content.map((ContentObject) => (
          <>
            <h3>{ContentObject.heading}</h3>
            <p>{ContentObject.content}</p>
          </>
        ))}
      </>
    );
  };

  const ShowCaseTestimonialOverviewType5 = (content) => {
    let leftCS = [];
    let rightCS = [];

    for (let a = 0; a < content.length; a++) {
      if (!Boolean(a % 2)) {
        leftCS.push(content[a]);
      } else {
        rightCS.push(content[a]);
      }
    }
    return (
      <>
        <h2>Testimonials Overview</h2>
        <div class="accordion-single js-acc-single accordion-toggle disabledHeading">
          <div className="left">
            {leftCS.map((content) => (
              <div class="accordion-single-item js-acc-item">
                <h3 class="accordion-single-title js-acc-single-trigger">
                  {content.heading}
                </h3>
                <div class="accordion-single-content">
                  <div className="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
                <span class="acc-toggle"></span>
              </div>
            ))}
          </div>
          <div className="right">
            {rightCS.map((content) => (
              <div class="accordion-single-item js-acc-item">
                <h3 class="accordion-single-title js-acc-single-trigger">
                  {content.heading}
                </h3>
                <div class="accordion-single-content">
                  <div className="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
                <span class="acc-toggle"></span>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <PublicHeaderNavigation />

      <BreadCrumbPanelNew
        breadcrumbs={props.vendorTestimonials?.breadcrumb_links}
      />
      <section class="vendor_page_header_section">
        <div class="container">
          <div class="cls_back">
            <Link to={props.vendorCommon.profile_url}>Back to Profile</Link>
          </div>
          <div class="vendor_page_main_heading">
            <h1>{`${props.vendorCommon.testimonial_count} ${props.vendorCommon.name} Testimonials`}</h1>
          </div>
        </div>
      </section>
      <div class="vendor_portal_filter_section">
        <div class="container">
          <VendorFilter
            sizeOptions={props?.vendorTestimonials?.company_size_options || []}
            industryOptions={props?.vendorTestimonials?.industry_options || []}
            sortByOptions={props.vendorTestimonials.sort_by_options}
            productOptions={props.vendorTestimonials.product_options}
            paginationInfo={props.vendorTestimonials.pagination}
          />

          {/* <div className="right">
            <SearchResultPremium
              totalReviewCount={props.vendorTestimonials.total_reviews_count}
              paginationInfo={props.vendorTestimonials.pagination}
              paginationOn={paginationOn}
              itemOnPage={itemOnPage}
              reviewCount={props.vendorTestimonials.total_reviews_count}
            />
          </div> */}
        </div>
      </div>
      <section>
        <div className="middleSection vendor_testimonials_section">
          <div className="container">
            <div className="vendor_reviews_section testimonials">
              <TestimonialPremium {...props} />
            </div>
            <PaginationPremium
              {...props}
              paginationOn={paginationOn}
              setPaginationOn={setPaginationOn}
              itemOnPage={itemOnPage}
              setItemOnPage={setItemOnPage}
              pageData={Array.apply(
                null,
                Array(props?.vendorTestimonials?.pagination?.num_pages)
              ).map((val, idx) => ({ page: idx + 1 }))}
              paginationInfo={props.vendorTestimonials.pagination}
              toggleLoader={toggleLoader}
            />
            {/* <section className="vendor_block_section">
              <div className="vendor_profile_main_content_block testimonials">
                <div className="vendor_testimonials_content_block">
                  <div className="vendor_portal_top_header_block">
                    <h1>{`${props.vendorCommon.name} Testimonials`}</h1>
                    {ShowContentOnTestimonial(
                      props.vendorTestimonials,
                      props?.location?.pathname
                    )}
                  </div>
                </div>
              </div>
            </section> */}
          </div>
        </div>
      </section>

      <PublicFooterNavigation />
    </>
  );
};

const PremiumTestimonialRefreshWithRouter = withRouter(
  PremiumTestimonialRefresh
);
const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorTestimonials: state.vendorTestimonials,
    vendorProfile: state.vendorProfile,
  };
};

export default connect(mapStateToProps)(PremiumTestimonialRefreshWithRouter);
